<template>
  <div class="white-container equity-page">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-tabs v-model="activeName" :before-leave="beforeLeave" class="equity-tabs">
      <el-tab-pane label="新品优先权" name="one" />
      <el-tab-pane label="限量包装券" name="two" />
      <el-tab-pane label="免费洗鞋券" name="three" />
      <el-tab-pane label="运动体验券" name="four" />
      <el-tab-pane label="活动专属优惠" name="five" />
      <el-tab-pane label="促销优先权" name="six" />
      <el-tab-pane label="品牌活动邀请" name="seven">
        <el-form class="search-bar" :inline="true" size="small">
          <el-form-item label="活动主题">
            <el-input v-model="search.titles" placeholder="活动主题" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select ref="statusBox" v-model="search.adminStatus" placeholder="请选择状态">
              <el-option label="全部" value="" />
              <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item class="search-form-item">
            <el-input v-model.number="search.id" type="number" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="searchSubmit">查询</el-button>
            <el-button @click="searchReset">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
          <el-table-column prop="id" label="ID" width="80" fixed />
          <el-table-column prop="startTime" label="权益主标题">
            <template v-slot="{ row }">
              <div v-for="(item,index) in row.titles" :key="item+index">{{ item }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="publishTime" label="权益发布时间">
            <template v-slot="{ row }">
              <span>{{ row.publishTime && $moment(row.publishTime).format('YYYY.MM.DD HH:mm') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="publishTime" label="报名卡片下架时间">
            <template v-slot="{ row }">
              <span>{{ row.offlineTime && $moment(row.offlineTime).format('YYYY.MM.DD HH:mm') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="adminStatus" label="活动状态">
            <template v-slot="{ row }">
              <el-tag v-if="row.adminStatus === 2" class="el-tag--yellow" size="mini">草稿</el-tag>
              <el-tag v-if="row.adminStatus === 3" class="el-tag--end" size="mini">活动结束</el-tag>
              <el-tag v-if="row.adminStatus === 4" class="el-tag--red" size="mini">报名中</el-tag>
              <el-tag v-if="row.adminStatus === 5" class="el-tag--red" size="mini">报名结束</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template v-slot="{ row }">
              <el-button v-if="row.adminStatus === 2" size="small" type="text" class="link-color" @click="edit(row.id)">编辑</el-button>
              <el-button v-if="[3, 4, 5].includes(row.adminStatus)" size="small" type="text" class="link-color" @click="read(row.id)">查看</el-button>
              <el-button v-if="row.adminStatus === 2" size="small" type="text" class="link-color" @click="postOnline(row.id)">发布权益</el-button>
              <el-button v-if="[4, 5].includes(row.adminStatus)" size="small" type="text" class="link-color" @click="postOfflineDialog(row.id)">下架此项权益</el-button>
              <el-button v-if="[2, 3].includes(row.adminStatus)" size="small" type="text" class="link-color" @click="remove(row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="周年纪念礼" name="eight" />
    </el-tabs>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
  </div>
</template>
<script>
import Dialog from '@/components/Dialog';
import { BenefitsRoutes } from '@/model/Benefits';

export default {
  components: { Dialog },
  data() {
    // 状态 0：预热 1：已开始 2：草稿 3：已结束 4：报名中 5：报名结束 6：活动中
    const statusList = [
      { id: 2, value: '草稿' },
      { id: 3, value: '活动结束' },
      { id: 4, value: '报名中' },
      { id: 5, value: '报名结束' },
    ];

    return {
      BenefitsRoutes,
      activeName: 'seven',
      statusList,
      search: {
        id: null,
        adminStatus: null,
        titles: null,
      },
      list: [],
      formDialogShow: false,
      information: {},
      currentID: undefined,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.list = [];
      this.$Api.benefits.query({ type: 6, brandActivity: this.search }).then(res => {
        if (res?.brandActivity?.length) {
          this.list = res.brandActivity;
        }
      });
    },
    beforeLeave(activeName, oldActiveName) {
      this.$router.push({ path: this.BenefitsRoutes[activeName] || this.BenefitsRoutes['one'] });
    },
    add() {
      this.$router.push({ path: '/member/brandEventInvitation/add' });
      console.log('新增');
    },
    searchSubmit() { this.fetchData(); },
    searchReset() {
      this.search = {
        adminStatus: null,
        titles: null,
        id: null,
      };
      this.searchSubmit();
    },
    edit(id) {
      this.$router.push({ path: '/member/brandEventInvitation/edit', query: { id } });
    },
    read(id) {
      this.$router.push({ path: '/member/brandEventInvitation/edit', query: { id, readOnly: 1 } });
    },
    postOnline(id) {
      this.$Api.benefits.publish({ type: 1, id }).then(res => {
        this.$message.success('发布成功');
        this.fetchData();
      });
    },
    postOfflineDialog(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: 'offline',
        icon: 'warn',
        subTitle: '如已对外发布，请谨慎操作，确定下架此项权益吗？',
      };
    },
    postOffline() {
      this.$Api.benefits.offShelf({ type: 1, id: this.currentID }).then(res => {
        this.$message.success('下架成功');
        this.fetchData();
      });
    },
    submitSuccess(operation) {
      if (operation === 'offline') {
        this.postOffline();
      }
    },
    remove(id) {
      this.$Api.benefits.del({ type: 1, id }).then(res => {
        this.$message.success('删除成功');
        this.fetchData();
      });
    },
  },
};

</script>
<style lang="less" scoped>
.equity-page {
  position: relative;

  display: flex;
  flex-direction: column;

  min-height: calc(100vh - 178px);
  :deep(.equity-tabs) {
    flex: 1;

    height: 100%;
    .el-tabs__header {
      margin: 0 0 30px;
    }
    .common-table {
      min-height: calc(100vh - 358px);
    }
  }
}
</style>
